import _objectSpread from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.timers.js";
import { defineComponent, reactive, toRefs, inject, onUnmounted, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import LeftMenu from './leftMenu/index';
import { _login, _user } from '@/api/index';
import { getCountryLogo, parseMoney, localStorageClear } from '@/util';
import { useStore } from 'vuex';
import Cookies from 'js-cookie';
import LangSelector from '@/components/lang-sel';
export default defineComponent({
  name: 'MainPage',
  components: {
    'left-menu': LeftMenu,
    'language-selector': LangSelector
  },
  setup: function setup() {
    var timer = null;
    var router = useRouter();
    var store = useStore();
    var state = reactive({
      themeData: inject('$themeData'),
      clientWidth: 0,
      loginTime: null,
      currentTime: new Date().getTime(),
      baseUrl: window.location.protocol + '//' + window.location.host,
      helpMenuVisible: false,
      showVideoList: false,
      currentVideo: null,
      videoModalVisible: false,
      videoList: [{
        id: 0,
        title: 'pages_help_video_receivable_management',
        description: 'pages_help_video_desc_receivable_management',
        enDuration: '0:21',
        cnDuration: '0:38',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%94%B6%E6%AC%BE%E4%BA%BA%E7%AE%A1%E7%90%86%E8%8B%B1%E6%96%87.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%94%B6%E6%AC%BE%E4%BA%BA%E7%AE%A1%E7%90%86.mp4'
      }, {
        id: 1,
        title: 'pages_help_video_add_payee',
        description: 'pages_help_video_desc_add_payee',
        enDuration: '1:24',
        cnDuration: '1:14',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%96%B0%E5%A2%9E%E6%94%B6%E6%AC%BE%E4%BA%BA%E8%8B%B1%E6%96%87.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E6%96%B0%E5%A2%9E%E6%94%B6%E6%AC%BE%E4%BA%BA.mp4'
      }, {
        id: 2,
        title: 'pages_help_video_balance_query',
        description: 'pages_help_video_desc_balance_query',
        enDuration: '0:12',
        cnDuration: '0:24',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BD%99%E9%A2%9D%E6%9F%A5%E8%AF%A2%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BD%99%E9%A2%9D%E6%9F%A5%E8%AF%A2.mp4'
      }, {
        id: 3,
        title: 'pages_help_video_same_name_payment',
        description: 'pages_help_video_desc_same_name_payment',
        enDuration: '0:42',
        cnDuration: '0:34',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE.mp4'
      }, {
        id: 4,
        title: 'pages_help_video_diff_name_payment',
        description: 'pages_help_video_desc_diff_name_payment',
        enDuration: '0:35',
        cnDuration: '0:42',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%8F%91%E8%B5%B7%E9%9D%9E%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E4%BB%98%E6%AC%BE%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%8F%91%E8%B5%B7%E9%9D%9E%E5%90%8C%E5%90%8D%E4%BB%98%E6%AC%BE%E4%BB%98%E6%AC%BE.mp4'
      }, {
        id: 5,
        title: 'pages_help_video_payment_review',
        description: 'pages_help_video_desc_payment_review',
        enDuration: '0:19',
        cnDuration: '0:27',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E5%A4%8D%E6%A0%B8%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E5%A4%8D%E6%A0%B8.mp4'
      }, {
        id: 6,
        title: 'pages_help_video_payment_details',
        description: 'pages_help_video_desc_payment_details',
        enDuration: '0:12',
        cnDuration: '0:36',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E6%98%8E%E7%BB%86%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E4%BB%98%E6%AC%BE%E6%98%8E%E7%BB%86.mp4'
      }, {
        id: 7,
        title: 'pages_help_video_currency_exchange',
        description: 'pages_help_video_desc_currency_exchange',
        enDuration: '0:44',
        cnDuration: '0:44',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%A4%96%E5%B8%81%E5%85%91%E6%8D%A2%E8%8B%B1%E6%96%87%E7%89%88.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E5%A4%96%E5%B8%81%E5%85%91%E6%8D%A2.mp4'
      }, {
        id: 8,
        title: 'pages_help_video_financial_management',
        description: 'pages_help_video_desc_financial_management',
        enDuration: '0:30',
        cnDuration: '0:26',
        category: 'basic',
        enVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86%E8%8B%B1%E6%96%87.mp4',
        cnVideoUrl: 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/%E8%B4%A2%E5%8A%A1%E7%AE%A1%E7%90%86.mp4'
      }],
      // 节假日通知数据 - 将从后台API读取
      holidayNotifications: [],
      currentHolidayIndex: 0,
      currentHolidayItem: null,
      holidayVisible: true,
      // 控制淡入淡出的可见性
      holidayTimer: null,
      holidayDetailVisible: false,
      selectedHoliday: null
    });
    onMounted(function () {
      state.clientWidth = document.documentElement.clientWidth;
    });
    onUnmounted(function () {
      window.onmousemove = null;
      clearInterval(timer);
      stopHolidayRotation(); // 清理节假日通知定时器
    });
    var init = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              loadMouseWatch();
              loadLoginTime();
              loadTimer();
              store.dispatch('getCurList');
              // 加载节假日通知
              _context.n = 1;
              return loadHolidayNotifications();
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function init() {
        return _ref.apply(this, arguments);
      };
    }();

    // 模拟从后台API加载节假日通知
    var loadHolidayNotifications = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var formatDate, formatTitle, formatContent, formatDuration, response, i, item, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              formatDate = function formatDate(date) {
                // date is yyyyMMdd format, convert to yyyy-MM-dd
                if (!date || date.length !== 8) return date;
                return "".concat(date.slice(0, 4), "-").concat(date.slice(4, 6), "-").concat(date.slice(6));
              };
              formatTitle = function formatTitle(title) {
                // split by |
                if (!title) return '';
                var parts = title.split('|');
                var cnTitle = parts[0] || '';
                var enTitle = parts[1] || '';
                var locale = localStorage.getItem('locale-language') || 'en';
                return locale === 'zh' ? cnTitle : enTitle;
              };
              formatContent = function formatContent(data) {
                var content = '';
                var cnContent = data.notifyCn;
                var enContent = data.notifyEn;
                var locale = localStorage.getItem('locale-language') || 'en';
                if (locale === 'zh') {
                  return cnContent || enContent || content;
                }
                return enContent || cnContent || content;
              };
              formatDuration = function formatDuration(duration) {
                // original format: 2025-10-01 -- 2025-10-08
                return duration;
              };
              _context2.p = 1;
              _context2.n = 2;
              return _user.queryRecentHolidays();
            case 2:
              response = _context2.v;
              if (response.data.succ) {
                _context2.n = 3;
                break;
              }
              state.holidayNotifications = [];
              return _context2.a(2);
            case 3:
              for (i = 0; i < response.data.data.length; i++) {
                item = {
                  date: formatDate(response.data.data[i].holidayDate),
                  content: formatContent(response.data.data[i]),
                  currency: response.data.data[i].currency || '',
                  title: formatTitle(response.data.data[i].remark),
                  duration: formatDuration(response.data.data[i].duration || '')
                };
                state.holidayNotifications.push(item);
              }

              // 数据加载完成后启动旋转显示
              if (state.holidayNotifications.length > 0) {
                startHolidayRotation();
              }
              console.log('Holiday notifications loaded:', state.holidayNotifications.length);
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error('Failed to load holiday notifications:', _t);
              state.holidayNotifications = []; // 失败时设为空数组
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 4]]);
      }));
      return function loadHolidayNotifications() {
        return _ref2.apply(this, arguments);
      };
    }();
    var signOut = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _login.loginOut();
            case 1:
              Cookies.remove('last_page_name');
              Cookies.remove('SESSION_ID');
              localStorageClear();
              router.replace('/login');
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function signOut() {
        return _ref3.apply(this, arguments);
      };
    }();
    var loadTimer = function loadTimer() {
      timer = setInterval(function () {
        loadIsExpired();
      }, 5000);
    };
    var loadIsExpired = function loadIsExpired() {
      if (new Date().getTime() - state.currentTime > 5 * 1000 * 60) {
        clearInterval(timer);
        router.push('/user_leave');
      }
    };
    var loadMouseWatch = function loadMouseWatch() {
      window.onmousemove = function () {
        state.currentTime = new Date().getTime();
      };
    };
    var loadLoginTime = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _login.queryLastLoginDate();
            case 1:
              res = _context4.v;
              if (res.data.succ) state.loginTime = res.data.data.lastLoginDate;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function loadLoginTime() {
        return _ref4.apply(this, arguments);
      };
    }();

    // 帮助菜单相关方法
    var toggleHelpMenu = function toggleHelpMenu() {
      state.helpMenuVisible = !state.helpMenuVisible;
    };
    var closeHelpMenu = function closeHelpMenu() {
      state.helpMenuVisible = false;
      state.showVideoList = false;
    };
    var backToMainMenu = function backToMainMenu() {
      state.showVideoList = false;
    };
    var playVideo = function playVideo(video) {
      state.currentVideo = video;
      state.videoModalVisible = true;
    };
    var closeVideoModal = function closeVideoModal() {
      state.videoModalVisible = false;
      state.currentVideo = null;
    };
    var openUserGuide = function openUserGuide() {
      // 打开使用指南
      // const guideUrl = state.baseUrl + '/help/guide'
      // window.open(guideUrl, '_blank')
      var cnHelpPdfUrl = 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/EASYWAY%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf';
      var enHelpPdfUrl = 'https://ew-pub.oss-cn-hongkong.aliyuncs.com/pub/Easyway%20Operation%20Manual%20English%20version.pdf';
      // according language, open different pdf
      var lang = localStorage.getItem('locale-language') || 'zh';
      var helpPdfUrl = lang === 'zh' ? cnHelpPdfUrl : enHelpPdfUrl;
      window.open(helpPdfUrl, '_blank');

      // closeHelpMenu()
    };
    var openVideoHelp = function openVideoHelp() {
      // 显示视频帮助二级页面
      state.showVideoList = true;
    };
    var contactSupport = function contactSupport() {
      // 联系客服 - 可以打开在线客服窗口或跳转到联系页面
      var supportUrl = state.baseUrl + '/help/contact';
      window.open(supportUrl, '_blank');
      closeHelpMenu();
    };
    var openFeedback = function openFeedback() {
      // 打开反馈页面
      var feedbackUrl = state.baseUrl + '/help/feedback';
      window.open(feedbackUrl, '_blank');
      closeHelpMenu();
    };

    // 节假日通知相关方法
    var startHolidayRotation = function startHolidayRotation() {
      if (state.holidayNotifications.length === 0) return;

      // 设置第一个通知
      state.currentHolidayIndex = 0;
      state.currentHolidayItem = state.holidayNotifications[0];
      state.holidayVisible = true;

      // 清除已有定时器
      if (state.holidayTimer) {
        clearInterval(state.holidayTimer);
      }

      // 如果只有一个通知，不需要循环
      if (state.holidayNotifications.length === 1) return;

      // 设置定时器，实现淡入淡出切换
      state.holidayTimer = setInterval(function () {
        // 开始淡出
        state.holidayVisible = false;

        // 500ms后切换内容并淡入
        setTimeout(function () {
          state.currentHolidayIndex = (state.currentHolidayIndex + 1) % state.holidayNotifications.length;
          state.currentHolidayItem = state.holidayNotifications[state.currentHolidayIndex];
          state.holidayVisible = true;
        }, 500);
      }, 5000);
    };
    var stopHolidayRotation = function stopHolidayRotation() {
      if (state.holidayTimer) {
        clearInterval(state.holidayTimer);
        state.holidayTimer = null;
      }
    };
    var showHolidayDetail = function showHolidayDetail(holiday) {
      state.selectedHoliday = holiday;
      state.holidayDetailVisible = true;
    };
    var formatHolidayContent = function formatHolidayContent(content) {
      if (!content) return '';
      // 处理各种可能的换行符格式
      return content.replace(/\\n/g, '\n') // 转换字符串字面量 \n
      .replace(/\\r\\n/g, '\n') // 转换 \r\n
      .replace(/\r\n/g, '\n') // 转换真正的 \r\n
      .replace(/\r/g, '\n'); // 转换单独的 \r
    };
    var openDownload = function openDownload() {
      // 打开资料下载页面
      var downloadUrl = state.baseUrl + '/help/download';
      window.open(downloadUrl, '_blank');
      closeHelpMenu();
    };
    init();
    return _objectSpread({
      getCountryLogo: getCountryLogo,
      parseMoney: parseMoney,
      signOut: signOut,
      init: init,
      loadHolidayNotifications: loadHolidayNotifications,
      toggleHelpMenu: toggleHelpMenu,
      closeHelpMenu: closeHelpMenu,
      backToMainMenu: backToMainMenu,
      openUserGuide: openUserGuide,
      openVideoHelp: openVideoHelp,
      playVideo: playVideo,
      closeVideoModal: closeVideoModal,
      contactSupport: contactSupport,
      openFeedback: openFeedback,
      openDownload: openDownload,
      startHolidayRotation: startHolidayRotation,
      stopHolidayRotation: stopHolidayRotation,
      showHolidayDetail: showHolidayDetail,
      formatHolidayContent: formatHolidayContent
    }, toRefs(state));
  }
});